import {Component, OnInit} from '@angular/core';
import {tabs} from '../../data/static/SelfEnrolTabs';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import {UntypedFormGroup} from '@angular/forms';
import * as SelfEnrollActions from '../store/SelfEnroll.action';
import {MessageService} from 'src/app/services/message.service';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-service-and-terms',
  templateUrl: './service-and-terms.component.html',
  styleUrls: ['./service-and-terms.component.css']
})
export class ServiceAndTermsComponent implements OnInit {
  tabs = [];
  el: any;
  email1: string;
  email2: string;
  emailForm: UntypedFormGroup;
  agree = false;

  constructor(
    private router: Router,
    private store: Store<fromApp.AppState>,
    private messageService: MessageService,
    private authService: AuthService) {
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.tabs = tabs;
  }

  next() {
    const authUser = this.authService.getUser();
    const payload = {email: authUser.email, timestamp: Date.now()};
    this.store.dispatch(new SelfEnrollActions.Sign_ESign(payload));
    this.router.navigate(['/selfEnroll/information']);
  }

}
